module.exports = __webpack_public_path__ + "static/media/ully.4e2e4b5d.svg";